<template>
  <v-app>
    <v-navigation-drawer permanent expand-on-hover app dark>
      <v-list>
        <v-list-item v-for="(item, i) in items" :key="i" :to="item.to" router exact>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app >
      <div class="d-flex align-center">
        <v-img
          alt="75 jaar vrijheid"
          class="shrink mr-4"
          contain
          src="@/assets/banner.png"
          transition="scale-transition"
          width="120"
        />
      </div>
      <v-spacer></v-spacer>
      <a href="https://play.google.com/store/apps/details?id=nl.nosmallthing.ommen75jaarbevrijding">
        <v-img src="@/assets/google-play-badge.png" width="140" />
        <span class="sr-only">Ontdek het op Google Play</span>
      </a>
      <a href="https://apps.apple.com/nl/app/75-jaar-bevrijding-ommen/id1506650489?mt=8">
        <v-img src="@/assets/download-appstore.svg" height="40" />
        <span class="sr-only">Download in de app store</span>
      </a>
    </v-app-bar>>
    <v-content>
      <router-view />
    <v-footer
      absolute
      class="font-weight-medium"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        Deze website hoort bij de app '75 jaar bevrijding Ommen' - 
        <router-link :to="'download'">download</router-link> nu!
      </v-col>
    </v-footer>
       
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: "Home",
    titleTemplate: "%s | app 75 jaar vrijheid Ommen",
    meta: [
      {
        "og:title": "App bij 75 jaar vrijheid Ommen",
        "og:description":
          "Informatie over de app, download en link naar specifieke informatie uit de app!"
      }
    ]
  },
  components: {},

  data() {
    return {
      items: [
        {
          icon: "mdi-home",
          title: "Home",
          to: "/"
        },
        {
          icon: "mdi-download",
          title: "Download",
          to: "/download"
        },
        // {
        //   icon: "mdi-map-outline",
        //   title: "Routes",
        //   to: "/routes"
        // },
        // {
        //   icon: "mdi-map-marker",
        //   title: "Points",
        //   to: "/points"
        // },
        // {
        //   icon: "mdi-newspaper-variant-multiple-outline",
        //   title: "Articles",
        //   to: "/articles"
        // },
        {
          icon: "mdi-information-outline",
          title: "Privacy",
          to: "/privacy"
        }
      ]
    };
  }
};
</script>
<style>
.text {
  white-space: pre-line;
  word-wrap: break-word;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
